import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NbAccordionModule, NbButtonModule, NbCardModule } from '@nebular/theme';
import { ApprovalV2Component } from './approval-v2.component';
import { ApprovalDetailsV2Module } from '../approval-details-v2/approval-details-v2.module';



@NgModule({
  declarations: [ApprovalV2Component],
  imports: [
   CommonModule,
           NbButtonModule,
           FlexLayoutModule,
           NbAccordionModule,
           NbCardModule,
           ApprovalDetailsV2Module
  ],
  exports: [ApprovalV2Component]
})
export class ApprovalsV2Module { }
